import { render, staticRenderFns } from "./addDesensitize.vue?vue&type=template&id=2d8f9956&scoped=true&"
import script from "./addDesensitize.vue?vue&type=script&lang=js&"
export * from "./addDesensitize.vue?vue&type=script&lang=js&"
import style0 from "./addDesensitize.vue?vue&type=style&index=0&id=2d8f9956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f9956",
  null
  
)

export default component.exports